<template>  
  <div>
  <q-card class="bg-grey-2">
  <q-card-section>
    <img :src="img1Source" width="100%">
  </q-card-section>
  <div class="content">
    <q-card-section>
      <img :src="img2Source">
    </q-card-section>
    <q-card-section>
      <p>{{ address }}</p>
      <p class="text-faded"><a :href="eMailTo">{{ eMail }}</a></p>
      <p>{{ tel }}</p>
      <p class="text-faded">{{ $versionText }}</p>
      <p class="text-faded">Quasar Version: {{$q.version}}</p>
    </q-card-section>
  </div>
</q-card>   
  </div>
</template>

<script>
import { openURL } from 'quasar'

export default {
  name: 'SideDialog1',
  data () {
    return {
      positions: []
    }
  },
  methods: {
    
  },
  computed: {
    img1Source: function () {
      if(this.$org == 2){
        return '/images/Rastrealo.png'
      }
      if(this.$org == 4){
        return '/images/gpsturix.png'
      }
      return '/images/Insafety.png'
    },
    img2Source: function () {
      if(this.$org == 2){
          return '/images/RastrealoMap.png'
      }
      if(this.$org == 4){
          return '/images/GpsturixMap.png'
      }     
      return '/images/InsafetyMap.png' 
    },
    address: function () {
      if(this.$org == 2){
          return 'Edif Bonampak 77 Of. 408 Cancún, Q. Roo México'
      }
      if(this.$org == 4){
          return 'Edif Bonampak 77 Of. 408 Cancún, Q. Roo México'
      } 
      return 'Insafety GmbH, Bahnhofstrasse 3, CH-8001 Zürich'   
    },
    eMailTo: function () {
      if(this.$org == 2){
          return 'mailto:soporte@rastrealo.com'
      }
      if(this.$org == 4){
          return 'mailto:soporte@gpsturix.com'
      }
      return 'mailto:welcome@insafety.ch'
    },
    eMail: function () {
      if(this.$org == 2){
          return 'soporte@rastrealo.com'
      }
      if(this.$org == 4){
          return 'soporte@gpsturix.com'
      }
      return 'welcome@insafety.ch'
    },
    tel: function () {
      if(this.$org == 2){
          return '(998) 887-8150'
      }
      if(this.$org == 4){
          return '(998) 887-8150'
      }  
      return '+41 44 500 21 52'  
    }
  }
}

function error(err) {
  console.log(`ERROR(${err.code}): ${err.message}`);
}

</script>

<style scoped>

</style>
